export const pushParams = (params) => {
  if (typeof window !== "undefined") {
    const { pathname } = window.location
    const cacheBuster = localStorage.getItem("cacheBuster") || Date.now()
    localStorage.setItem("params_cacheBuster", cacheBuster)

    const newUrl = `${pathname}${params}`
    window.history.pushState({ path: newUrl }, "", newUrl)
  }
}